import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import { StyledInput } from "@components/Styled/FormElements";
import { ComponentProps } from "@ts/components";
import { clsx } from "clsx";
import React, { ChangeEvent } from "react";
import FormLabel from "./FormLabel";

export type FormInputProps = ComponentProps & {
  className?: string;
  color?: string;
  defaultValue?: string;
  error?: string;
  handleChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  handleInvalid?: (event: ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  maxLength?: number;
  name: string;
  optional?: boolean;
  placeholder?: string;
  placeholderColor?: string;
  required?: boolean;
  requiredFields?: {
    [key: string]: boolean;
  };
  type?: string;
  value?: string | boolean;
  width?: string;
};

const Wrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "h-full w-full px-mini",
      props.width === "1/2" && "md:w-1/2",
    )}
  />
);

const Input = withFocusRing((props: any) => (
  <StyledInput
    {...props}
    className={clsx(
      props.className,
      props.error && "text-warning",
      props.color === "light" ? "border-white text-white" : "text-primary",
      props.requiredError && "border-b-2 border-warning text-warning",
    )}
  />
));

const ErrorMessage = (props: any) => (
  <p
    {...props}
    className={clsx(props.className, "mt-micro text-caption text-warning")}
  />
);

const FormInput = ({
  className,
  color,
  defaultValue,
  error,
  handleChange,
  handleInvalid,
  id,
  label,
  maxLength,
  name,
  optional,
  placeholder,
  placeholderColor,
  readOnly,
  required,
  requiredFields,
  type,
  value,
  width,
  "data-testid": dataTestId,
}: FormInputProps) => {
  return (
    <Wrapper width={width} className={className}>
      <FormLabel
        label={label}
        id={id}
        required={required}
        optional={optional}
        requiredError={requiredFields?.[id]}
      />
      <Input
        color={color}
        data-testid={dataTestId}
        defaultValue={defaultValue}
        error={error}
        requiredError={requiredFields?.[id]}
        id={id}
        maxLength={maxLength}
        name={name}
        onChange={handleChange}
        onInvalid={handleInvalid}
        placeholder={placeholder}
        placeholderColor={placeholderColor}
        readOnly={readOnly}
        required={required}
        aria-invalid={requiredFields?.[id]}
        aria-describedby={id}
        type={type}
        value={value}
      />
      {requiredFields?.[id] && (
        <ErrorMessage>This field is required.</ErrorMessage>
      )}
    </Wrapper>
  );
};
export default FormInput;
